module.exports = __webpack_public_path__ + "img/xiaozi_yixiubao.1ab628a0.png";